// Copyright (c) 2023 WiseTime. All rights reserved.

import {
  CreateTimelineMarkerRequest,
  TimelineMarker
} from "../../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { concat, mergeMap, Observable, of } from "rxjs"
import { Action } from "redux"
import * as ToolbarActions from "../actions"
import { catchError, filter } from "rxjs/operators"
import { timelineClient } from "../../../../app/rpc/client"
import { grpc } from "../../../../app/rpc/executor"
import { showSnackBar } from "../../../snackbar/actions"
import { t } from "@lingui/macro"
import * as TimelineSlice from "../../slices/timeline"

type CreateTimelineMarkerRpc = (request: CreateTimelineMarkerRequest) => Observable<TimelineMarker>

export const createTimelineMarker = (createTimelineMarkerRpc: CreateTimelineMarkerRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(ToolbarActions.createTimelineMarker.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(createTimelineMarkerRpc),
          mergeMap(timelineMarker =>
            concat(
              of(TimelineSlice.addTimelineMarker(timelineMarker.toObject())),
              of(showSnackBar({
                message: t({ id: "msg_timeline_marker_added", message: "Marker added." }),
                messageType: "SUCCESS",
              }))
            )
          ),
          catchError(handleError),
        )
      ),
    )

const createTimelineMarkerRpc = (request: CreateTimelineMarkerRequest): Observable<TimelineMarker> =>
  grpc(() => timelineClient.createTimelineMarker(request, null))

const handleError = () => {
  return of(showSnackBar({
    message: t({ id: "msg_timeline_marker_failed", message: "Failed to add marker. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
    messageType: "ERROR",
  }))
}

export default createTimelineMarker(createTimelineMarkerRpc)
